<template>
  <section id="faq">
    <div class="hero-image">
      <img src="../../static/static-css/img/faqs/faqs.jpg" alt />
      <div class="overlay"></div>
    </div>
    <div class="faqs-content">
      <div class="container">
        <div class="dasboard-content container">
          <div class="tittle">
            <h3>FAQ’s</h3>
          </div>
          <div class="content">
            <!-- accordion here -->
            <div id="accordion">
              <div class="card faqs faqs-card">
                <div class="card-header" id="headingOne">
                    <button class="btn btn-link" data-toggle="collapse" data-target="#collapse1" aria-expanded="true" aria-controls="collapse1">
                      <h5 data-lbl="Q." >Does the Financial Statements Translation Tool ("FSTT") make GAAP or IFRS adjustments?</h5>
                    </button>
                </div>

                <div id="collapse1" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                  <div class="card-body">
                      <div data-lbl="A." class="faq-ans">
                        <p>While the FSTT does not make adjustments to the figures to comply with International Financial Reporting Standards ("IFRS") or Generally Accepted Accounting Principles ("GAAP"), it does present the numbers in a format similar to the IFRS and GAAP format, which has wide acceptability amongst international audiences including analysts and accountants.</p>
                      </div>
                  </div>
                  </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="headingTwo">
                  <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                    <h5 data-lbl="Q."> What is the main use of this Financial Statements Translation Tool ("FSTT")?</h5>
                  </button>
                </div>
                <div id="collapse2" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                  <div class="card-body">
                      <div data-lbl="A." class="faq-ans">
                        <p>The tool translates the financial statements into English, which is very useful for users who do not read or understand Russian language. The financial statements line items are re-organized into an internationally recognized format and layout. While adjustments required to make the financial statements GAAP- or IFRS-compliant are not made, analysts and accountants will find key numbers in the right places.</p>
                      </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading3">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                        <h5 data-lbl="Q." >Why aren't adjustments to make financials IFRS or GAAP compliant made?</h5>
                    </button>
                </div>
                <div id="collapse3" class="collapse" aria-labelledby="heading3" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>Adjusting finanical statement numbers to ensure compliance with GAAP or IFRS is a manual process as it relies on investigating and understanding what certain line items are based on. The Financial Statements Translation Tool ("FSTT") lacks the ability to do that without human intervention. But that is certainly something we would like to add to this tool in the near future. If you have any suggestions, please use the Contact Form to send them to us.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading4">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                        <h5 data-lbl="Q." >What if Russian Federation financial reporting or accounting standards change?</h5>
                    </button>
                </div>
                <div id="collapse4" class="collapse" aria-labelledby="heading4" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>We check the standards periodically to ensure our tool is up to date. But the Financial Statements Translation Tool ("FSTT") does not incorporate changes to the Russian Federation Accounting or Reporting Standards in real time. Therefore we cannot make any guarantees or assurances with respect to any accounting or reporting standards changes which have taken place since the last time we updated the tool.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading6">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                        <h5 data-lbl="Q." >How often do you update the Financial Statements Translation Tool ("FSTT")?</h5>
                    </button>
                </div>
                <div id="collapse6" class="collapse" aria-labelledby="heading6" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>We generally update the tool periodically. We do not have any pre-set update dates.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading6a">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse6a" aria-expanded="false" aria-controls="collapse6a">
                        <h5 data-lbl="Q." >Why do you ask for foreign exchange rate?</h5>
                    </button>
                </div>
                <div id="collapse6a" class="collapse" aria-labelledby="heading6a" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>The Financial Statements Translation Tool ("FSTT") can convert revenue into USD for assessment, if you opt for it. But the user is required to either enter the exchange rate, or confirm the exchange rate that the tool pulls from an external source. It is important for the user to decide which exchange rate he or she would like to use for converting financial statements into USD.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading7">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                        <h5 data-lbl="Q." >Should the user enter current foreign exchange rate or historical rate (as of the date of the financial statements)?</h5>
                    </button>
                </div>
                <div id="collapse7" class="collapse" aria-labelledby="heading7" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>It's the user's choices. In some cases, it makes sense to use the current rate, in other cases using historical rate would be better. The rate which the user selects normally depends on how the translation will be used.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading8">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                        <h5 data-lbl="Q." >Does the Financial Statements Translation Tool ("FSTT") apply the same foreign exchange rate to both current fiscal year and the preceding fiscal year?</h5>
                    </button>
                </div>
                <div id="collapse8" class="collapse" aria-labelledby="heading8" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>Yes, the FSTT applies current exchange rate to both the most recent fiscal year and the preceding year.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading9">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                        <h5 data-lbl="Q." >Are you currently working on any enhancements?</h5>
                    </button>
                </div>
                <div id="collapse9" class="collapse" aria-labelledby="heading9" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        At present the translation is based on a rules-based system. We review and re-calibrate the rules and features from time to time with the intention of making the Financial Statements Translation Tool ("FSTT") more accurate. In future we see incorporating artificial intelligence and self-learning as the next big steps in terms of enhancements. We welcome feedback and suggestions. Please use the
                        <a @click="contactus" class="acolor">Contact Us</a> form to send us your comments.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading10">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                        <h5 data-lbl="Q." >Why does the tool not allow editing data once a translation has been generated?</h5>
                    </button>
                </div>
                <div id="collapse10" class="collapse" aria-labelledby="heading10" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        This is a precautionary measure to prevent misuse i.e. paying for one translation but editing numbers to generate multiple translations. The fee charged for translations, although modest, is very important as a lot of resources are required for operating and maintaining this tool and the website.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading11">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
                        <h5 data-lbl="Q." >Why are translations not available after 30 days?</h5>
                    </button>
                </div>
                <div id="collapse11" class="collapse" aria-labelledby="heading11" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        In order to keep our prices low, we cannot make translated financials available to customers beyond 30 days, as that would take up a lot of resources for storage, security and accessibility.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading12">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                        <h5 data-lbl="Q." >What is your subscription (payment plan) enrolment policy?</h5>
                    </button>
                </div>
                <div id="collapse12" class="collapse" aria-labelledby="heading12" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        Subscription payment is automatically withdrawn from the user's Credit Card, PayPal or Debit Account on the anniversary date (or the working day immediately following anniversary date) of each month. The billing cycle starts on the date you signed up for the subscription, and ends on the same date less a day at the following month. Subscription fee is charged in the beginning of each billing cycle.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading13">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse13" aria-expanded="false" aria-controls="collapse13">
                        <h5 data-lbl="Q." >What is your subscription (payment plan) cancellation policy?</h5>
                    </button>
                </div>
                <div id="collapse13" class="collapse" aria-labelledby="heading13" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        Subscriptions may be cancelled anytime with a 1-month notice. No prorated refunds are available. E.g. Payment for the month of June is charged on June 9th. User cancels the subscription on June 23rd. Payment for the month of July will be withdrawn on July 9th, and the user will have full access until the Aug 8th. Subscription and access will be deactivated on Aug 9th. So, basically, if you cancel mid-billing-cycle, you end up paying for one additional month.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading14">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse14" aria-expanded="false" aria-controls="collapse14">
                        <h5 data-lbl="Q." >How do I cancel my subscription (payment plan)?</h5>
                    </button>
                </div>
                <div id="collapse14" class="collapse" aria-labelledby="heading14" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        Subscription Cancellation option can be found under subscription details in user profile when you are signed-in.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading15">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse15" aria-expanded="false" aria-controls="collapse15">
                        <h5 data-lbl="Q." >Who reviews the financial statements translations?</h5>
                    </button>
                </div>
                <div id="collapse15" class="collapse" aria-labelledby="heading15" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        No one. Translations are not reviewed by a human.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading16">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse16" aria-expanded="false" aria-controls="collapse16">
                        <h5 data-lbl="Q." >Can I use this service without disclosing the name of the company whose financials I am entering?</h5>
                    </button>
                </div>
                <div id="collapse16" class="collapse" aria-labelledby="heading16" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        You can enter a nickname or code instead of the real name of the company. If you are a financial institution bound by confidentiality requirements, you can purchase a copy of this translation software from us, and store data on your own servers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading17">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse17" aria-expanded="false" aria-controls="collapse17">
                        <h5 data-lbl="Q." >Where can I find your Terms and Conditions of Use?</h5>
                    </button>
                </div>
                <div id="collapse17" class="collapse" aria-labelledby="heading17" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        Under Quick Links
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading18">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse18" aria-expanded="false" aria-controls="collapse18">
                        <h5 data-lbl="Q." >Where can I find your Privacy and Cookies policy?</h5>
                    </button>
                </div>
                <div id="collapse18" class="collapse" aria-labelledby="heading18" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        Under Quick Links
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card faqs faqs-card">
                <div class="card-header" id="heading19">
                    <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapse19" aria-expanded="false" aria-controls="collapse19">
                        <h5 data-lbl="Q." >Can I disable cookies?</h5>
                    </button>
                </div>
                <div id="collapse19" class="collapse" aria-labelledby="heading19" data-parent="#accordion">
                  <div class="card-body">
                    <div data-lbl="A." class="faq-ans">
                      <p>
                        If you are not comfortable with cookies, you can disable cookies in your browser according to your browser instructions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    contactus () {
      window.location = `${process.env.HOST}#testimonial`
    }
  },
  created () {
    this.$store.commit('ISLOADING', false)
  }
};


</script>

<style>
.acolor {
  color: #337ab7 !important;
}
.hero-image {
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0,0,0,0.5);
}

.hero-image img {
  max-height: 500px;
  width: 100%;
}

.faqs {
  margin-bottom: 30px;
}

/* Style for accordion */
.accordion {
  background-color: #eee;
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  transition: 0.4s;
}

.active, .accordion:hover {
  background-color: #ccc;
}

.panel {
  padding: 0 18px;
  display: none;
  background-color: white;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/FAQ.vue